import React, { PropsWithChildren, useEffect, useMemo } from 'react';
import Auth from '../auth';

interface ThemeContextProps {
    theme: string;
}

export const ThemeContext = React.createContext<ThemeContextProps>({
    theme: 'light',
} as ThemeContextProps);

export function ThemeProvider({ children }: Readonly<PropsWithChildren>) {
    const [currentTheme, setCurrentTheme] = React.useState<string>('light');

    const { user } = Auth.useAuth();

    useEffect(() => {
        const lightTheme = 'light';

        import(`../../themes/${lightTheme}.scss`).then(() => {
            setCurrentTheme(lightTheme);
        });
    }, [currentTheme, user?.type]);

    const theme = useMemo(() => ({ theme: currentTheme }), [currentTheme]);

    return (
        <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
    );
}

export const useTheme = () => React.useContext(ThemeContext);
